import axios from "axios"
import { BASEURL } from "./url_helper";
import { getAuthorizationToken } from "./storagehelper"
//pass new generated access token here

const axiosApi = axios.create({
  baseURL:BASEURL
})
// axiosApi.defaults.headers.common["Authorization"] = "token";

axiosApi.interceptors.response.use(
  response => response,
  error => error.response
)

const addToken = () => {
  axiosApi.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${getAuthorizationToken()}`
//  axiosApi.defaults.headers.common['Referrer-Policy'] = 'no-referrer';
}
const headers = {
  headers: { "Content-Type": "application/json; charset=UTF-8" },
}

export async function get(url, config = {}) {
  addToken()
  return await axiosApi
    .get(url, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function post(url, data, config = {}) {
  addToken()
  return axiosApi
    .post(url, { ...data }, headers)
    .then(response => response.data || response)
    .catch(err => err.response?.data || err)
}

export async function postform(url, data, config = {}) {
  addToken()
  return axiosApi
    .post(url, data )
    .then(response => response.data || response)
    .catch(err => err.response?.data || err)
}
export async function putform(url, data, config = {}) {
  addToken()
  return axiosApi
    .put(url,data)
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}
export async function put(url, data, config = {}) {
  addToken()
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function del(url, config = {}) {
  addToken()
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
    .catch(err => err.response?.data || err)
}

export async function patch(url, data, config = {}) {
  addToken();
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((err) => err.response?.data || err);
}
export async function patchform(url, data, config = {}) {
  addToken();
  return axiosApi
    .patch(url ,data)
    .then((response) => response.data)
    .catch((err) => err.response?.data || err);
}

export async function attachpatch(
  url,
  data,
  config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  }
) {
  return axiosApi.post(url, data, { ...config }).then(response => response.data).catch(err => err);
}

export async function exportFile(url, data, type) {
  try {
    const response = await axiosApi.get(url, {
      params: data,
      headers: {
        Authorization: `Bearer ${getAuthorizationToken()}`,
      },
      responseType: "blob",
    })
    if (response.data instanceof Blob) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${type}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error("Response data is not a blob:", response.data);
    }
  } catch (error) {
    console.error("Error fetching the file:", error);
  }
}